import CashBackRewards from 'components/RwdBasket/RwdBasketLayout/BIBenefits/CashBackRewards/CashBackRewards';

export default CashBackRewards;
